enum CompanyDialogMode {
  CREATE,
  DETAIL,
  EDIT
}

export default CompanyDialogMode;